module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/will-vux-stop-maintaining-56.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/will-vux-stop-maintaining.md
// module id = 759
// module chunks = 172